import { render, staticRenderFns } from "./TwitterLink.vue?vue&type=template&id=79bb2a12&"
import script from "./TwitterLink.vue?vue&type=script&lang=js&"
export * from "./TwitterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports